import classNames from "classnames";

// background-color: $dark-gray !important;
// 	color: $white !important;
// 	border: 2px solid $sesh-color !important;

export function SeshPrimaryButton(
	props: React.HTMLProps<HTMLButtonElement> & {
		is_loading?: boolean;
		custom_size?: "small" | "medium";
	}
) {
	const { is_loading, ...base_props } = props;

	return (
		<button
			{...base_props}
			className={classNames(
				props.className,
				"w-full border-sesh-primary bg-base-dark font-bold text-white ",
				{
					// Important css here to override bulmas button stuff
					"button is-loading !rounded-none !border-2 !border-sesh-primary !bg-base-dark":
						is_loading,
					"input-disabled": props.disabled || is_loading,
					"hover:bg-base-light": !props.disabled,
					"h-8 border px-2 text-sm": props.custom_size === "small",
					"h-10 border-2 px-4 text-base":
						!props.custom_size || props.custom_size === "medium",
				}
			)}
			type={
				(base_props.type ?? "button") as "button" | "submit" | "reset"
			}
		></button>
	);
}
